import { render } from "./DropdownChecked.vue?vue&type=template&id=06f056c4&scoped=true"
const script = {}

import "./DropdownChecked.vue?vue&type=style&index=0&id=06f056c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f056c4"]])

export default __exports__